import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  finanziatori: {
    id: 'bando_finanziatori',
    defaultMessage: 'Finanziato con fondi europei',
  },
});

const BandoFinanziatori = ({ content }) => {
  const intl = useIntl();
  return content?.finanziato ? (
    <>
      <h3 className="h5">{intl.formatMessage(messages.finanziatori)}</h3>
    </>
  ) : null;
};

BandoFinanziatori.propTypes = {
  content: PropTypes.shape({
    riferimenti_bando: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};
export default BandoFinanziatori;
